/* RelaxMaster — 'In winkelmand' toont bevestiging i.p.v. sprong naar /cart. 2026-08-13
   Onderschept #cta / #sCta op de custom productpagina's (.rm-pdp en #rm-amandel),
   voegt toe via /cart/add.js en toont een toast. Valt netjes terug bij fouten. */
(function () {
  if (window.__rmPdpNotify) return;
  window.__rmPdpNotify = true;

  var css =
    '.rm-toast{position:fixed;z-index:100000;right:20px;bottom:20px;max-width:340px;background:#fff;border:1px solid #e7e2d2;border-radius:14px;box-shadow:0 14px 38px -14px rgba(45,73,71,.5);padding:14px 16px;display:flex;gap:12px;align-items:flex-start;transform:translateY(18px);opacity:0;transition:transform .25s ease,opacity .25s ease;font-family:inherit;}' +
    '.rm-toast.rm-show{transform:translateY(0);opacity:1;}' +
    '.rm-toast__check{flex:0 0 auto;width:34px;height:34px;border-radius:50%;background:#eaf3ee;color:#2f7d58;display:flex;align-items:center;justify-content:center;}' +
    '.rm-toast__check svg{width:20px;height:20px;}' +
    '.rm-toast__body{flex:1;min-width:0;}' +
    '.rm-toast__title{font-size:14.5px;font-weight:600;color:#2d4947;}' +
    '.rm-toast__name{font-size:13px;color:#5c6f6b;margin-top:1px;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}' +
    '.rm-toast__actions{margin-top:10px;display:flex;gap:8px;}' +
    '.rm-toast__btn{font-size:13px;font-weight:600;border-radius:10px;padding:8px 13px;cursor:pointer;text-decoration:none;line-height:1;border:1px solid #2d4947;}' +
    '.rm-toast__btn--ghost{color:#2d4947;background:#fff;}' +
    '.rm-toast__btn--solid{color:#fff;background:#2d4947;border-color:#2d4947;}' +
    '.rm-toast__close{flex:0 0 auto;background:none;border:0;color:#9aaca8;cursor:pointer;font-size:20px;line-height:1;padding:0 2px;}' +
    '@media (max-width:600px){.rm-toast{left:12px;right:12px;bottom:12px;max-width:none;}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var toastEl, hideTimer;
  function hideToast() { if (toastEl) toastEl.classList.remove('rm-show'); }
  function showToast(name) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'rm-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.innerHTML =
        '<div class="rm-toast__check"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6L9 17l-5-5"/></svg></div>' +
        '<div class="rm-toast__body"><div class="rm-toast__title">Toegevoegd aan winkelwagen</div><div class="rm-toast__name"></div>' +
        '<div class="rm-toast__actions"><a class="rm-toast__btn rm-toast__btn--ghost" href="/cart">Winkelwagen</a><a class="rm-toast__btn rm-toast__btn--solid" href="/checkout">Afrekenen</a></div></div>' +
        '<button type="button" class="rm-toast__close" aria-label="Sluiten">×</button>';
      document.body.appendChild(toastEl);
      toastEl.querySelector('.rm-toast__close').addEventListener('click', hideToast);
    }
    toastEl.querySelector('.rm-toast__name').textContent = name || '';
    void toastEl.offsetWidth;
    toastEl.classList.add('rm-show');
    clearTimeout(hideTimer);
    hideTimer = setTimeout(hideToast, 5000);
  }

  function updateBubble(sections) {
    try {
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble && sections && sections['cart-icon-bubble']) {
        var doc = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
        var fresh = doc.querySelector('#cart-icon-bubble');
        if (fresh) bubble.innerHTML = fresh.innerHTML;
      }
    } catch (e) {}
  }

  function buildBody(scope) {
    var variantId = scope.getAttribute('data-variant-id');
    if (!variantId) return null;
    var body = { id: variantId, quantity: 1 };
    var sel = document.querySelector('#purchaseOpts .popt.selected');
    var mode = sel ? sel.getAttribute('data-mode') : 'once';
    if (mode === 'routine') {
      var rf = document.querySelector('.rf-opt[aria-selected="true"]');
      if (rf && rf.getAttribute('data-id')) body.selling_plan = rf.getAttribute('data-id');
      body.quantity = 1;
    } else if (mode === 'bundle3') {
      body.quantity = 3;
    } else {
      var q = 1;
      var qEl = document.getElementById('qty') || scope.querySelector('input[type="number"]') || scope.querySelector('[name="quantity"]');
      if (qEl) { var v = parseInt(qEl.value, 10); if (!isNaN(v) && v > 0) q = v; }
      body.quantity = q;
    }
    return body;
  }

  function handleAdd(btn) {
    var scope = btn.closest('[data-variant-id]');
    if (!scope) return false;
    var body = buildBody(scope);
    if (!body || !body.id) return false;
    body.sections = ['cart-icon-bubble'];
    body.sections_url = window.location.pathname;
    var label = btn.innerHTML;
    btn.innerHTML = '✓ Toegevoegd';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { btn.innerHTML = label; return; }
        updateBubble(res.sections);
        showToast(res.product_title || res.title || '');
        setTimeout(function () { btn.innerHTML = label; }, 1500);
      })
      .catch(function () { btn.innerHTML = label; });
    return true;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('#cta, #sCta') : null;
    if (!btn) return;
    if (handleAdd(btn)) { e.stopPropagation(); e.preventDefault(); }
  }, true);
})();
